import { softValidateResponse } from "@/server/validation";
import { instance } from "../api-instance";
import { GetGroupsResponseSchema } from "./schemas";

export const UserExperimentsApi = {
  getGroups: (
    applicationId: string,
    { signal }: { signal?: AbortSignal } = {}
  ) =>
    instance
      .get(`experiment/byApplication?applicationId=${applicationId}`, {
        signal,
      })
      .then(softValidateResponse(GetGroupsResponseSchema))
      .then((res) => res?.data),
};
